import React from 'react';
import { Button } from 'react-bootstrap';

import IconGG from '../Utils/Icon';

const StepMap = ({ currentStep, steps }) => (
  <div className="custom-steps-map-container">
    <hr className="custom-steps-map--line" />
    <div className="custom-steps-map">
      {steps.map((step, index) => {
        const summaryStep = steps[steps.length - 1];
        return (
          <Button
            key={`step-${index.toString()}`}
            className={`custom-steps-map--step btn non-clickable ${step <= currentStep ? 'filled' : ''}`}
          >
            {step === summaryStep ? <IconGG icon="eye" size="lg" /> : <>{step}</>}
          </Button>
        );
      })}
    </div>
  </div>
);

export default StepMap;
